import React from 'react';

import { useBowser } from 'common/hooks/bowser/useBowser';

import { routes } from '../../../routes/routes.constants';
import svgIcons, { SvgProps } from '../../svgIcons';
import SvgIconUrl from '../SvgIconUrl/SvgIconUrl.component';

const Logo: React.FC<React.PropsWithChildren<{ icon?: SvgProps }>> = ({ icon = svgIcons.Logo() }) => {
  const { isDesktop } = useBowser();

  return (
    <a data-test='logo' className='logo' aria-label='logo' href={routes.getWebsite()}>
      <SvgIconUrl className='icon-logo' symbol={isDesktop ? icon : svgIcons.LogoMob()} />
    </a>
  );
};

export default Logo;
